// extracted by mini-css-extract-plugin
export default {"img":"PaymentMethodIcon_img__ZaYpF"};